import UiHelper from './UiHelper';

class OffcanvasSlider
{
    static init()
    {
        this.showBtn = UiHelper.getNode('.js-sidebar-toggle');
        this.sidebar = UiHelper.getNode('.js-offcanvas-sidebar');
        //this.siteWrap = UiHelper.getNode('.js-site-wrap');
        this.header = UiHelper.getNode('.js-site-header');
        this.content = UiHelper.getNode('.js-site-content');
        this.footer = UiHelper.getNode('.js-site-footer');
        this.cover = UiHelper.getNode('.js-offcanvas-sidebar-cover');

        this.showBtn.addEventListener('click', e => this.showSidebar());
        this.cover.addEventListener('click', e => this.hideSidebar());
        this.cover.addEventListener('touchstart', e => this.hideSidebar());

        // Hide toggle button if menu is empty
        if(!UiHelper.getNode('.primary-nav')) {
            this.hideToggleButton();
        }
    }

    static hideToggleButton()
    {
        this.showBtn.classList.add('offcanvas-sidebar-toggle--hide');
    }

    static showSidebar()
    {
        this.header.classList.add('site-header--sidebar-visible');
        this.content.classList.add('site-content--sidebar-visible');
        this.footer.classList.add('site-footer--sidebar-visible');
        this.sidebar.classList.add('offcanvas-sidebar--visible');
        this.cover.classList.add('offcanvas-sidebar-cover--visible');
    }

    static hideSidebar()
    {
        this.header.classList.remove('site-header--sidebar-visible');
        this.content.classList.remove('site-content--sidebar-visible');
        this.footer.classList.remove('site-footer--sidebar-visible');
        this.sidebar.classList.remove('offcanvas-sidebar--visible');
        setTimeout(() => this.cover.classList.remove('offcanvas-sidebar-cover--visible'), 200); // timeout to prevent touchstart dismisses the cover and click event is executed right after
    }
}

export default OffcanvasSlider;
